/* ADVANZ · Carrusel y agregar al carrito
   Un solo archivo para todas las secciones que usen la card. */

(function () {
  'use strict';

  /* ============================================================
     CARRUSEL
     ============================================================ */
  if (!customElements.get('advanz-carousel')) {
    class AdvanzCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.bar = this.querySelector('[data-progress]');
        if (!this.viewport) return;

        this.onScroll = this.update.bind(this);
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);

        if (this.prev) {
          this.prev.addEventListener('click', () => this.move(-1));
        }
        if (this.next) {
          this.next.addEventListener('click', () => this.move(1));
        }

        // El primer cálculo espera al layout para no leer medidas en cero
        requestAnimationFrame(() => this.update());
      }

      disconnectedCallback() {
        if (this.viewport) {
          this.viewport.removeEventListener('scroll', this.onScroll);
        }
        window.removeEventListener('resize', this.onScroll);
      }

      step() {
        const card = this.viewport.querySelector('.advanz-card');
        if (!card) return this.viewport.clientWidth;
        const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      move(dir) {
        this.viewport.scrollBy({ left: this.step() * dir, behavior: 'smooth' });
      }

      update() {
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        const x = this.viewport.scrollLeft;

        // 2px de tolerancia: el scroll con subpíxeles nunca llega al entero exacto
        if (this.prev) this.prev.classList.toggle('is-off', x <= 2);
        if (this.next) this.next.classList.toggle('is-off', x >= max - 2);

        // Si todo cabe en pantalla, las flechas y el aviso no tienen para qué existir
        this.classList.toggle('no-scroll', max <= 2);

        if (this.bar) {
          this.bar.style.width = (max > 0 ? (x / max) * 100 : 0) + '%';
        }

        // Centra las flechas sobre la imagen, no sobre la card completa
        const media = this.viewport.querySelector('.advanz-card__media');
        if (media) {
          const alto = media.getBoundingClientRect().height;
          if (alto > 0) this.style.setProperty('--c-arrow-top', alto / 2 + 'px');
        }
      }
    }

    customElements.define('advanz-carousel', AdvanzCarousel);
  }

  /* ============================================================
     CONTADOR DEL CARRITO
     Se actualiza sin recargar la página. Si el carrito estaba vacío
     la burbuja no existe en el DOM, así que hay que crearla.
     ============================================================ */
  function actualizarBurbuja(cantidad) {
    const contenedor = document.getElementById('cart-icon-bubble');
    if (!contenedor) return;

    let burbuja = contenedor.querySelector('.cart-count-bubble');

    if (cantidad > 0) {
      if (!burbuja) {
        burbuja = document.createElement('div');
        burbuja.className = 'cart-count-bubble';
        contenedor.appendChild(burbuja);
      }
      burbuja.innerHTML =
        '<span aria-hidden="true">' + (cantidad < 100 ? cantidad : '') + '</span>' +
        '<span class="visually-hidden">' + cantidad + '</span>';
    } else if (burbuja) {
      burbuja.remove();
    }

    // Otros temas y apps escuchan este evento para refrescar sus propios contadores
    document.dispatchEvent(new CustomEvent('advanz:cart-updated', { detail: { count: cantidad } }));
  }

  function sincronizarCarrito() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then((r) => r.json())
      .then((cart) => {
        actualizarBurbuja(cart.item_count);
        return cart;
      })
      .catch(() => null);
  }

  /* ============================================================
     AGREGAR AL CARRITO
     ============================================================ */
  if (window.advanzAddBound) return;
  window.advanzAddBound = true;

  function abrirCarrito(state) {
    // Cada tema expone el carrito de forma distinta. Se prueban por orden de
    // preferencia y, si ninguno responde, solo se actualiza el contador.
    const drawer = document.querySelector('cart-drawer');
    const notif = document.querySelector('cart-notification');

    try {
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
        return true;
      }
      if (notif && typeof notif.renderContents === 'function') {
        notif.renderContents(state);
        return true;
      }
    } catch (e) {
      /* cae al respaldo */
    }

    return false;
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-advanz-add]');
    if (!btn || btn.disabled) return;

    e.preventDefault();

    const label = btn.querySelector('.advanz-card__btn-label');
    const textoOriginal = label ? label.textContent : '';

    btn.disabled = true;
    btn.classList.add('is-loading');

    // Se piden las mismas secciones que el carrito de Trade actualiza al abrirse
    // (cajón + ícono del header). Si falta una, el cajón no alcanza a abrirse.
    const carrito = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const secciones = carrito && typeof carrito.getSectionsToRender === 'function'
      ? carrito.getSectionsToRender().map(function (s) { return s.id; })
      : [];

    const cuerpo = {
      items: [{ id: Number(btn.dataset.variantId), quantity: 1 }]
    };
    if (secciones.length) {
      cuerpo.sections = secciones.join(',');
      cuerpo.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify(cuerpo)
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status) throw new Error(data.description || data.message);

        abrirCarrito(data);

        // El contador se sincroniza siempre, se haya abierto el carrito o no
        sincronizarCarrito();

        if (label) {
          label.textContent = 'Agregado';
          setTimeout(function () {
            label.textContent = textoOriginal;
          }, 1800);
        }

        document.dispatchEvent(new CustomEvent('advanz:added', { detail: data }));
      })
      .catch(function () {
        if (label) {
          label.textContent = 'No disponible';
          setTimeout(function () {
            label.textContent = textoOriginal;
          }, 2000);
        }
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

    /* ============================================================
     ARRASTRE CON MOUSE
     Deslizamiento con inercia. El ajuste magnético se apaga durante el
     arrastre y vuelve al soltar, si no la mano pelea con el imán.
     ============================================================ */
  document.addEventListener('pointerdown', function (e) {
    // Solo botón principal del mouse. El táctil ya desliza de forma nativa.
    if (e.pointerType !== 'mouse' || e.button !== 0) return;

    const viewport = e.target.closest('[data-viewport]');
    if (!viewport) return;

    const inicioX = e.clientX;
    const inicioScroll = viewport.scrollLeft;
    let arrastro = false;

    // Historial corto de posiciones para calcular la velocidad al soltar
    let ultimoX = e.clientX;
    let ultimoT = performance.now();
    let velocidad = 0;
    let inercia = null;

    const suaveOriginal = viewport.style.scrollBehavior;
    const imanOriginal = viewport.style.scrollSnapType;
    viewport.style.scrollBehavior = 'auto';

    function mover(ev) {
      const delta = ev.clientX - inicioX;

      if (!arrastro && Math.abs(delta) > 5) {
        arrastro = true;
        viewport.classList.add('is-dragging');
        // El imán se apaga recién aquí: apagarlo antes provoca un salto
        viewport.style.scrollSnapType = 'none';
      }

      if (arrastro) {
        viewport.scrollLeft = inicioScroll - delta;

        const ahora = performance.now();
        const dt = ahora - ultimoT;
        if (dt > 0) {
          // Se promedia con la velocidad anterior para suavizar el temblor
          velocidad = 0.8 * ((ultimoX - ev.clientX) / dt) + 0.2 * velocidad;
          ultimoX = ev.clientX;
          ultimoT = ahora;
        }
        ev.preventDefault();
      }
    }

    function frenar() {
      // Cada cuadro avanza un poco menos, hasta detenerse
      velocidad *= 0.94;
      viewport.scrollLeft += velocidad * 16;

      const tope = viewport.scrollWidth - viewport.clientWidth;
      const chocó = viewport.scrollLeft <= 0 || viewport.scrollLeft >= tope;

      if (Math.abs(velocidad) > 0.02 && !chocó) {
        inercia = requestAnimationFrame(frenar);
      } else {
        // Al detenerse vuelve el imán y encaja en el logo más cercano
        viewport.style.scrollSnapType = imanOriginal || '';
        viewport.style.scrollBehavior = suaveOriginal || '';
        inercia = null;
      }
    }

    function soltar() {
      document.removeEventListener('pointermove', mover);
      document.removeEventListener('pointerup', soltar);
      document.removeEventListener('pointercancel', soltar);

      viewport.classList.remove('is-dragging');

      if (arrastro) {
        // Se traga el clic que dispara el navegador después del arrastre
        const tragar = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        viewport.addEventListener('click', tragar, { capture: true, once: true });
        setTimeout(function () {
          viewport.removeEventListener('click', tragar, { capture: true });
        }, 50);

        if (inercia) cancelAnimationFrame(inercia);
        inercia = requestAnimationFrame(frenar);
      } else {
        viewport.style.scrollSnapType = imanOriginal || '';
        viewport.style.scrollBehavior = suaveOriginal || '';
      }
    }

    document.addEventListener('pointermove', mover);
    document.addEventListener('pointerup', soltar);
    document.addEventListener('pointercancel', soltar);
  });
})();